import { Validator } from '@vista-digital/validator';
export const defaultOccNotificationConfig = {
    dismissalTime: 3500
};
export const occNotificationConfigValidator = Validator.object({
    dismissalTime: Validator.number({ min: 0 })
});
//# sourceMappingURL=notification.js.map